import { useEffect, useState } from 'react';

export const useCookies = () => {
  const [shouldCookiesDisplay, setShouldCookiesDisplay] = useState(false);

  useEffect(() => {
    const cookiesAccepted = window.localStorage.getItem('cookiesAccepted');
    const controller = new AbortController();

    const firstInteraction = () => {
      setShouldCookiesDisplay(true);

      if (window.innerWidth < 600) {
        const field = document.createElement('input');
        field.setAttribute('type', 'text');
        document.body.appendChild(field);

        setTimeout(function () {
          field.focus();
          setTimeout(function () {
            field.setAttribute('style', 'display:none;');
          }, 50);
        }, 50);
      }

      controller.abort();
    };

    if (cookiesAccepted === null) {
      ['click', 'scroll', 'mousemove', 'touchstart'].forEach(function (e) {
        window.addEventListener(e, firstInteraction, {
          once: true,
          passive: true,
          signal: controller.signal,
        });
      });
    }

    return () => {
      if (cookiesAccepted === null) {
        controller.abort();
      }
    };
  }, []);

  const closeCookies = () => {
    setShouldCookiesDisplay(false);
  };

  return { shouldCookiesDisplay, closeCookies };
};
